export default "__VITE_ASSET__0aba3d6e__"